import { Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'genesis-frontend-recommendation-card-media',
    templateUrl: './recommendation-card-media.component.html',
    styleUrls: ['./recommendation-card-media.component.scss']
})
export class RecommendationCardMediaComponent {
    @Input() id = '';
    @Input() image = '';
    @Input() title = '';
    @Input() progress = 0;
    @Input() screenReaderText = '';
    @Input() playButton = true;
    @Input() showDuration = false;
    @Input() duration = '';

    @Output() mediaClick = new EventEmitter<void>();

    @HostBinding('class') class = 'recommendation-card-media';

    onMediaClick(): void {
        this.mediaClick.emit();
    }
}
